import { useMemo } from 'react';
import { usePortalPlatformData } from './usePortalPlatformData';
import { usePreviewContext } from './usePreviewContext';
export function isNodeVisible(node) {
  const hasLabel = typeof node.label === 'string' && node.label.length > 0;
  const isLive = node.live !== false;
  const isPublished = node.isPublished !== false;
  return hasLabel && isLive && isPublished;
}
function deactivateLinks(nodes) {
  return nodes.map(node => Object.assign({}, node, {
    url: null,
    linkTarget: null,
    children: node.children ? deactivateLinks(node.children) : undefined
  }));
}
export function useNavigationMenu() {
  var _portalPlatformData$c;
  const portalPlatformData = usePortalPlatformData();
  const {
    isPreview
  } = usePreviewContext();
  return useMemo(() => {
    var _menuData$children$fi, _menuData$children;
    // @ts-expect-error Menu Data is not typed
    const menuData = portalPlatformData.context.menuData;
    const visible = (_menuData$children$fi = menuData === null || menuData === void 0 || (_menuData$children = menuData.children) === null || _menuData$children === void 0 ? void 0 : _menuData$children.filter(isNodeVisible)) !== null && _menuData$children$fi !== void 0 ? _menuData$children$fi : [];
    return isPreview ? deactivateLinks(visible) : visible;
    // @ts-expect-error Menu Data is not typed
  }, [(_portalPlatformData$c = portalPlatformData.context) === null || _portalPlatformData$c === void 0 ? void 0 : _portalPlatformData$c.menuData, isPreview]);
}